export default __webpack_public_path__ + "static/media/portal-1.de5d51e8.png";